<template>
  <b-form-input
    :id="id"
    v-model.number="inputValue"
    :class="classes"
    :v-validate="{ required: inputRequired, min: minNumber }"
    type="number"
    :name="name"
    :onkeydown="KeydownString"
    :min="minNumber"
    :max="maxNumber"
    :size="size"
    @input="updateValue()"
  />
</template>

<script>
  export default {
    props: {
      id:             {type: String,  default: "" },
      classes:        {type: Array, default: Array },
      name:           {type: String,  default: "" },
      allowNegatives: {type: Boolean, default: true },
      minNumber:      {type: Number,  default: null },
      inputRequired:  {type: Boolean, default: true },
      maxNumber:      {type: Number,  default: null },
      defaultValue:   {type: Number,  default: 0  },
      size:           {type: String, default: "" }, // xs, sm, or lg
      allowDecimals:  {type: Boolean, default: false }
    },
    data: () => ({
      inputValue: 0
    }),
    computed: {
      KeydownString (){
        let disallowedChars = ['e','E','+'];
        if(this.allowNegatives === false){
          disallowedChars.push('-');
        }
        if(this.allowDecimals === false){
          disallowedChars.push('.');
        }

        var disallowedCharsString = "['" + disallowedChars.join("','") + "']";

        return `javascript: return ${disallowedCharsString}.includes(event.key) ? false : true`;
      },
      DefaultClasses () {
        return ["dn-number-input"];
      }    
    },
    created(){
      this.inputValue = this.minNumber || 0;
      this.updateValue();
      this.setSize();
    },
    methods: {
      updateValue () {
        if(this.inputValue === ""){
          this.inputValue = this.minNumber || 0;
        }
        if(this.maxNumber != null && this.inputValue > this.maxNumber){
          this.inputValue = this.maxNumber;
        }
        this.$emit("input", this.inputValue);
      },
      setSize () {
        if (this.size === "xs") {
          this.classes.push("dn-number-input--extra-small");
        }
      }
    }
  }
</script>

<style>
/* tag selector used to overwrite b-form class */
input.dn-number-input--extra-small {
  height: 1.4rem;
  line-height: 0;
}
</style>
